import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces'

export function useWorkerDataProcessSelector() {
    const exp = useSelector((state: StateExtended) => state.workers.watchExperimentDataProcess)
    return exp
}
export function useWorkerMeasurementDataProcessSelector() {
    const exp = useSelector((state: StateExtended) => state.workers.watchMeasurementExperimentDataProcess)
    return exp
}
